import { isObject } from './isObject';
import moment from 'moment';

export const normalizeDate = (form, format) => {
  Object.keys(form).map(key => {
    const obj = isObject(form[key]) && form[key];
    Object.keys(obj).map(item => {
      if (item.endsWith('_date')) {
        obj[item] =
          obj[item] && obj[item] !== '' ? moment(obj[item]).format(format) : '';
      }
      return null;
    });
    return null;
  });
  return form;
};
